import Swiper from "swiper";
import 'swiper/css';

export default class NewsSection {
  static init() {
    document.querySelectorAll(".news-section__swiper").forEach((el) => {
      const swiper = new Swiper(el, {
        slidesPerView: "auto",
        spaceBetween: 20,
        watchOverflow: true,
        centerInsufficientSlides: true,
        grabCursor: true,
        observer: true,
        observeParents: true,
        on: {
          lock(swiper) {
            swiper.allowTouchMove = false;
            swiper.unsetGrabCursor();
          },
          unlock(swiper) {
            swiper.allowTouchMove = true;
            swiper.setGrabCursor();
          },
        },
      });

      // Keep the overflow lock current when cards are added or removed.
      const cardsObserver = new MutationObserver(() => swiper.update());
      cardsObserver.observe(swiper.wrapperEl, { childList: true });
      swiper.on("destroy", () => cardsObserver.disconnect());
    });
  }
}
